//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react";

import { useTheme } from '@mui/material/styles';
import {
  InputBase,
} from '@mui/material';
import {updateField} from "api/prokey/prokey.websocket";
import {validate} from "./components/validation/index";
import {FAILURE_CODE, SUCCESS_CODE} from "constants/general";


//#endregion

export { validate };

//-----------------------------------------------------------------
export function Amount( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, field, has_focus } = props;

  const [ content , setContent ] = useState( props.value );

  const is_auto_mode      = localStorage.getItem( 'auto-mode' ) === 'true';
  const auto_mode_latency = localStorage.getItem( 'auto-mode-latency' ) * 1;

  //#endregion

  //#region [STYLES]

  const INPUT = {
    sx        : props.style       ,
    // ref       : props.inputRef ,
    inputRef  : props.inputRef    ,
    value     : content           ,
    onChange  : onChange          ,
    onKeyDown : onKeyDown         , 
    onBlur    : props.onBlur      ,
    name      : props.name        ,
    autoComplete : "off"          ,
    disabled  : field.isReadOnly  ,
    inputProps: { sx: props.inputStyle || props.style },
  }

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    if( is_auto_mode && has_focus ) setTimeout( autoKey, auto_mode_latency );
  }, [is_auto_mode, has_focus])
  
  useEffect( () => {
    setContent( props.value );
  }, [props?.value])

  //#endregion

  //#region [METHOD]

  //-----------------------------------------------------------------
  function autoKey() {
    //-----------------------------------------------------------------
    try {
      const key_enter = { key: 'Enter', ctrlKey: true };
      const event = new KeyboardEvent( 'keydown', key_enter );
      onKeyDown( event );
    } catch (error) {
      console.warn( error );
    }
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    try {
      setContent( event.target.value );
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    try {
      if (typeof props.onKeyDown === 'function') {
        props.onKeyDown(event);
      }

      const is_action_force = event.key === 'Enter' &&  event.ctrlKey  ;
      const is_action_enter = event.key === 'Enter' && !event.ctrlKey  ;
      const is_action_tab   = event.key === 'Tab'   && !event.shiftKey ;

      const actions = {
        is_action_force, is_action_enter, is_action_tab,
      }
      
      const result = props.confirm( actions, content );
      if( result && result.content !== content ) {
        setContent( result.content );
      }
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <InputBase { ...INPUT } />;
  }

  //#endregion

  return display();
}
